module.exports = __webpack_public_path__ + "static/img/14.a6f12bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/14.png
// module id = ekPz
// module chunks = 0